import React, { useEffect, useState, useContext } from "react";
import "./Warranty.css";

import modesLine from "../../../../assets/icons/voyahfree/drivingModes.png";
import carImage from "../../../../assets/images/voyahfree/warranty/warrantyCar.png";
import warrantyBadge from "../../../../assets/images/voyahfree/warranty/warrantylabel2.png";

import { LanguageContext } from "../../../../context/LanguageContext";
import { getPageContent } from "../../../../api/publicContent.api";

const Warranty = () => {
  const { currentLang } = useContext(LanguageContext);

  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    const loadContent = async () => {
      try {
        setLoading(true);
        setError(false);

        const response = await getPageContent("voyahfree", currentLang);

        // response.sections.warranty
        setData(response.sections);
      } catch (err) {
        console.error("CMS load error:", err);
        setError(true);
      } finally {
        setLoading(false);
      }
    };

    loadContent();
  }, [currentLang]);

  if (loading) return null;
  if (error || !data) return null;

  const { warranty } = data;
  const yearsText = warranty.warranty_years || "";
  const yearsNumber = yearsText.split(" ")[0] || "";
  const yearsLabel = yearsText.split(" ").slice(1).join(" ") || "";

  return (
    <section className="warranty-section">
      {/* TOP TEXT */}
      <div className="warranty-header">
        <p className="warranty-sub">
          {warranty.subtitle}
        </p>
        <p className="warranty-main">
          {warranty.main_text}
        </p>
      </div>

      {/* DRIVING MODES LINE */}
      <div className="warranty-modes-line">
        <img src={modesLine} alt="Driving modes" />
        <div className="elipse"></div>
      </div>

      {/* VISUAL */}
      <div className="warranty-visual">
        <img
          src={carImage}
          className="warranty-car"
          alt="Car"
        />

      <div className="warranty-badge">
  <img
    src={warrantyBadge}
    alt="Warranty background"
    className="warranty-badge-bg"
  />

  <div className="warranty-badge-text">
    <div className="warranty-title">
      {warranty.warranty_label}
    </div>

<div className="warranty-years">
  <span className="warranty-years-number">
    {yearsNumber}
  </span>
  <br />
  <span className="warranty-years-label">
    {yearsLabel}
  </span>
</div>

    <div className="warranty-km">
      {warranty.warranty_sub}
    </div>
  </div>
</div>
      </div>
    </section>
  );
};

export default Warranty;
